import Vue from "vue";
import Offset from "@/components/helper/Offset";
import Card from "@/components/material/Card";
import ChartCard from "@/components/material/ChartCard";
import Notification from "@/components/material/Notification";
import StatsCard from "@/components/material/StatsCard";

import AlertDialog from "@/components/dialog/AlertDialog";
import ErrorDialog from "@/components/dialog/ErrorDialog";
import ProgressDialog from "@/components/dialog/ProgressDialog";
import ConfirmDialog from "@/components/dialog/ConfirmDialog";
import OutputDialog from "@/components/dialog/OutputDialog";
import ModalOutputDialog from "@/components/dialog/ModalOutputDialog";

Vue.component(Offset.name, Offset);
Vue.component(Card.name, Card);
Vue.component(ChartCard.name, ChartCard);
Vue.component(Notification.name, Notification);
Vue.component(StatsCard.name, StatsCard);

Vue.component(AlertDialog.name, AlertDialog);
Vue.component(ErrorDialog.name, ErrorDialog);
Vue.component(ProgressDialog.name, ProgressDialog);
Vue.component(ConfirmDialog.name, ConfirmDialog);
Vue.component(OutputDialog.name, OutputDialog);
Vue.component(ModalOutputDialog.name, ModalOutputDialog);
